<!-- @format -->

@if (hasInvalidSelections) {
  <ng-container *transloco="let t">
    <fudis-heading [level]="3" id="invalid-selections-title">{{ t("PLAN_STRUCTURE_EDIT.INVALID_SELECTIONS_TITLE") }}</fudis-heading>
    @if (!hasModuleContentApplication() && !isModuleContentWorkflowRequired() && planHasActiveStudyRight()) {
      <fudis-notification [variant]="'danger'">
        <fudis-body-text>
          {{ t("PLAN_STRUCTURE_EDIT.INVALID_SELECTIONS_GUIDANCE_TEXT") }}
          <a
            fudisLink
            [title]="t('PLAN_STRUCTURE_EDIT.INVALID_SELECTIONS_LINK_TEXT')"
            [size]="'md'"
            [href]="'#'"
            (click)="openApplyForModuleContentWorkflowDialog()"></a>
        </fudis-body-text>
      </fudis-notification>
    }
    @for (courseUnit of invalidCourseUnits; track courseUnit) {
      <div class="sis-pt-sm">
        <sis-plan-structure-course-unit
          [courseUnit]="courseUnit"
          [planStateObject]="planStateObject"
          [planData]="planData"
          [headingLevel]="headingLevel"
          [action]="'select-to-plan'"
          [selected]="validatablePlan.isCourseUnitInPlan(courseUnit)"
          [showAttainment]="false"
          (actionChange)="handleCourseUnitToggle(courseUnit)">
        </sis-plan-structure-course-unit>
      </div>
    }
    @for (customCourseUnitAttainment of invalidCustomCourseUnitAttainments; track customCourseUnitAttainment) {
      <div class="sis-pt-sm">
        <sis-plan-structure-custom-course-unit-attainment
          [customCourseUnitAttainment]="customCourseUnitAttainment"
          [planStateObject]="planStateObject"
          [headingLevel]="headingLevel"
          [action]="'select-to-plan'"
          [selected]="validatablePlan.isCustomCourseUnitAttainmentInPlan(customCourseUnitAttainment)"
          (actionChange)="handleCustomCourseUnitAttainmentToggle(customCourseUnitAttainment)">
        </sis-plan-structure-custom-course-unit-attainment>
      </div>
    }
    @for (customStudyDraft of invalidCustomStudyDrafts; track customStudyDraft) {
      <div class="sis-pt-sm">
        <sis-plan-structure-custom-study-draft
          [customStudyDraft]="customStudyDraft"
          [headingLevel]="headingLevel"
          [action]="'select-to-plan'"
          [selected]="isCustomStudyDraftInPlan(customStudyDraft)"
          (actionChange)="handleCustomStudyDraftToggle(customStudyDraft)">
        </sis-plan-structure-custom-study-draft>
      </div>
    }
    @for (module of invalidModules; track module) {
      <div class="sis-pt-sm">
        @if (module.type === "DegreeProgramme") {
          <sis-plan-structure-degree-programme-box
            [module]="$any(module)"
            [planStateObject]="planStateObject"
            [planData]="planData"
            [headingLevel]="headingLevel"
            [action]="'select-to-plan'"
            [selected]="validatablePlan.isModuleInPlan(module.id)"
            (actionChange)="handleModuleToggle(module)">
          </sis-plan-structure-degree-programme-box>
        }
        @if (module.type === "StudyModule") {
          <sis-plan-structure-study-module-box
            [module]="$any(module)"
            [planStateObject]="planStateObject"
            [planData]="planData"
            [headingLevel]="headingLevel"
            [action]="'select-to-plan'"
            [selected]="validatablePlan.isModuleInPlan(module.id)"
            (actionChange)="handleModuleToggle(module)">
          </sis-plan-structure-study-module-box>
        }
      </div>
    }
    @for (customModuleAttainment of invalidCustomModuleAttainments; track customModuleAttainment) {
      <div class="sis-pt-sm">
        <sis-plan-structure-custom-module-attainment-box
          [customModuleAttainment]="customModuleAttainment"
          [planStateObject]="planStateObject"
          [headingLevel]="headingLevel"
          [action]="'select-to-plan'"
          [selected]="validatablePlan.isModuleAttainmentInPlan(customModuleAttainment.id)"
          (actionChange)="handleCustomModuleAttainmentToggle(customModuleAttainment)">
        </sis-plan-structure-custom-module-attainment-box>
      </div>
    }
  </ng-container>
}
